import React, { Component } from 'react';
import { View, Text, TouchableWithoutFeedback, Image } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import utils from '../utils';
import currencyMap from '../../../../Constant/currencyMap';
import { enabledStyle, disabledStyle } from '../commonStyles';
import PPLogUtil from '../../../../Utils/PPLogUtil';
import PriceBubble from '../../PriceBubble';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    insure: true,
    pay: true
};

const iconfontMap: { [propName: string]: string } = {
    1007: '\ue323'
};

const titleMap: { [propName: string]: string } = {
    1007: '酒店集团旗舰店'
};

const iconColorMap: { [propName: string]: string } = {
    1007: '#ef5e60'
};

interface Props {
    data: {
        sysCode: number;
        productTitle: string;
        productCount: number;
        fixFromDate: string;
        fixToDate: string;
        roomInfo: string;
        currency: string;
        fixPrice: string;
        bubbleImage?: string;
        bubbleText?: string;
        bubbleJumpUrl?: string;
        businessType?: string;
        convertPrice: string;
        fixConvertPrice: string;
        fixLoan: string;
        hasPaidMoney: boolean;
        hasLoan: boolean;
        fixPaidMoney: string;
        _disable: false;
        extData?: any;
        tryToSleepTaskStatusDesc?: string;
    };
}

class Hotel extends Component<Props> {
    componentDidMount(){
        const { bubbleImage, bubbleText, businessType } = this.props.data || {};
        if(bubbleImage || bubbleText){
            PPLogUtil.priceBubbleBtn('show','priceBubble',{
                businessType
            });
        }
    }
    public static formatData = (data: any) => {
        const newData = { ...data };

        // 酒店独有的位于title后面的闪住、信用住icon
        const orderTypeMaps = [
            {
                orderType: 1005002,
                title: '闪住'
            },
            {
                orderType: 1005005,
                title: '先住后付'// 信用住
            }
        ];
        orderTypeMaps.some((item) => {
            if (item.orderType === newData.orderType) {
                newData.icon = [
                    {
                        title: item.title
                    }
                ];
                return true;
            }
            return false;
        });
        // if (newData.orderType === 1005002) {
        //     newData.icon = [
        //         {
        //             title: '闪住'
        //         }
        //     ];
        // }

        // title
        newData.title = titleMap[newData.sysCode] || '酒店';

        // icon
        newData.iconfont = iconfontMap[newData.sysCode] || '\uf1f4';
        newData.iconColor = iconColorMap[newData.sysCode] || '#ef5e60';

        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.isCommonPriceTpl = false;
        newData.currency = (newData.currency || '').trim();
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        newData.hasOrderType = newData.orderType && newData.orderType === 1005002;
        newData.hasPaidMoney =
            newData.hasOrderType &&
            newData.paidMoney &&
            parseInt(newData.loan, 10) > 0 &&
            parseInt(newData.paidMoney, 10) > 0;
        newData.fixPaidMoney = utils.fixPrice(newData.paidMoney);

        newData.hasLoan = newData.hasOrderType && newData.loan && parseInt(newData.loan, 10) > 0;
        newData.fixLoan = utils.fixPrice(newData.loan);
        newData.fixFromDate = fixDate(newData.fromDate);
        newData.fixToDate = fixDate(newData.toDate);
        newData.night = getNight(newData.fixFromDate, newData.fixToDate);
        newData.roomInfo = buildRoomInfoStr(newData) || '';

        return newData;
    };
    public priceBubblePress = () => {
        const { bubbleJumpUrl,businessType,bigBubbleJumpUrl } = this.props.data || {};
        const jumpUrl = bubbleJumpUrl||bigBubbleJumpUrl||'';
        if(!jumpUrl)return;
        let url = jumpUrl;
        if((jumpUrl.indexOf('qunaraphone') === -1) && (jumpUrl.indexOf('qunariphone') === -1)){
            url = `${DeviceInfo.scheme}${jumpUrl}`;
        }
        Ext.Router.Bridge.sendScheme({ url }, () => null);
        PPLogUtil.priceBubbleBtn('click','priceBubble',{
            businessType
        });
    }
    public render() {
        const {
            data: {
                sysCode,
                productTitle,
                productCount,
                fixFromDate,
                fixToDate,
                roomInfo,
                currency,
                fixPrice,
                // 价格浮标
                bubbleImage='',
                bubbleText='',
                bigBubbleImage='',
                // 浮标跳转
                // bubbleJumpUrl='',
                convertPrice,
                fixConvertPrice,
                fixLoan,
                hasPaidMoney,
                hasLoan,
                fixPaidMoney,
                _disable,
                extData,
                tryToSleepTaskStatusDesc
            } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;
        return (
            <View style={styles.flex1}>
                <View style={styles.contentWrapper}>
                    <View style={styles.left}>
                        <Text style={styles.newOrderTitle} numberOfLines={2} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.HOTEL_TITLE)}>
                            {productTitle}
                        </Text>
                        {sysCode === 1007 ? (
                            <View>
                                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                    配送信息请咨询客服
                                </Text>
                                {Boolean(productCount) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                                        {`数量${productCount}`}
                                    </Text>
                                )}
                            </View>
                        ) : (
                            <View>
                                {Boolean(fixFromDate && fixToDate) && (
                                    <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.HOTEL_CHECK_IN)}>
                                        {`${fixFromDate} 至 ${fixToDate}`}
                                    </Text>
                                )}
                                <Text style={styles.newOrderSubTitle} numberOfLines={1} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.HOTEL_ROOM_INFO)}>
                                    {roomInfo}
                                </Text>
                            </View>
                        )}
                    </View>
                    <View style={styles.right}>
                        {Boolean(fixPrice) && (
                            <Text style={styles.orderPriceWrapper} numberOfLines={1}>
                                <Text style={styles.orderPriceCurrency}>{currencyMap[currency]}</Text>
                                <Text style={styles.orderPrice}>{fixPrice}</Text>
                            </Text>
                        )}
                        {Boolean(fixPrice && currency !== '&yen;' && convertPrice) && (
                            <Text style={[styles.orderPriceWrapper, styles.orderPriceConvert]}>
                                约合&yen;
                                {fixConvertPrice}
                            </Text>
                        )}
                        {Boolean(hasLoan) && (
                            <Text style={[styles.orderPriceWrapper, styles.orderPriceConvert]}>
                                欠款&yen;
                                {fixLoan}
                            </Text>
                        )}
                        {Boolean(hasPaidMoney) && (
                            <Text style={[styles.orderPriceWrapper, styles.orderPriceConvert]}>
                                已扣&yen;
                                {fixPaidMoney}
                            </Text>
                        )}
                        {/* {bubbleImage?(
                            <TouchableWithoutFeedback 
                                hitSlop={{
                                    left: 5,
                                    right: 5,
                                    top: 5,
                                    bottom: 5
                                }}
                                style={styles.priceBubble}
                                onPress={this.priceBubblePress}
                            >
                                <View style={styles.priceBubbleBox}>
                                    <Image source={{uri: bubbleImage}} style={styles.priceBubbleImage} />
                                </View>
                            </TouchableWithoutFeedback>
                        ):null} */}
                        <PriceBubble
                            bubbleImage={bubbleImage}
                            bubbleText={bubbleText}
                            bigBubbleImage={bigBubbleImage}
                            onPress={this.priceBubblePress}
                        />
                    </View>
                </View>
                {!Boolean(extData?.serviceProgress) && Boolean(tryToSleepTaskStatusDesc) && (
                    <View style={[styles.cardProgress, {
                        backgroundColor: _disable ? '#F7F8FA' : '#F2FCFD'
                    }]}>
                        <Text style={styles.cardProgressTitle}>试睡任务</Text>
                        <Text style={styles.cardProgressDesc} numberOfLines={1}>{tryToSleepTaskStatusDesc}</Text>
                    </View>
                )}
            </View>
        );
    }
}

export default Hotel;

function fixDate(dateStr: string) {
    let fixStr = '';
    let info;
    if (dateStr) {
        info = dateStr.split(' ');
        [fixStr] = info;
    }
    return fixStr;
}

const dayTime = 1000 * 60 * 60 * 24;

function getNight(fromDate: string, toDate: string) {
    const fromDayTime = utils.parseStr(fromDate);
    const toDayTime = utils.parseStr(toDate);
    if (fromDayTime && toDayTime) {
        return parseInt(String(Math.abs(fromDayTime - toDayTime) / dayTime), 10);
    }
}

function buildRoomInfoStr(data: {
    night: string;
    saleType: number;
    roomCount: number;
    roomType: string;
}) {
    const result = [];
    if (data) {
        data.night && result.push(`${data.night}晚  `);
        if (data.saleType && data.saleType === 1) {
            data.roomCount && result.push(`${data.roomCount}张床  `);
        } else {
            data.roomCount && result.push(`${data.roomCount}间  `);
        }
        data.roomType && result.push(data.roomType);
    }
    return result.join(' ');
}
